import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { AnnouncementsActionType, AnnouncementsStore } from './AnnouncementsReducer.types';

// @ts-ignore
const initialState: AnnouncementsStore = Immutable.fromJS({
  data: Immutable.List(),
  isFetching: false,
  failure: false,
});

const AnnouncementsReducer = handleActions(
  {
    DASHBOARD_ANNOUNCEMENTS_REQUEST: (state: AnnouncementsStore) => state.set('isFetching', true),

    DASHBOARD_ANNOUNCEMENTS_RESPONSE_FAILURE: (state: AnnouncementsStore) => state.set('isFetching', false).set('failure', true),

    AUTHENTICATION_LOGOUT: () => initialState,

    DASHBOARD_ANNOUNCEMENTS_RESPONSE: (state: AnnouncementsStore, action: AnnouncementsActionType) =>
      state.set('isFetching', false).set('data', Immutable.fromJS(action.payload.data.results)).set('failure', false),
  },
  initialState
);

export default AnnouncementsReducer;
